<template>
  <div class="flex vertical full-height">
    <div class="scrollable-container main">
      <BackNavigationItem :backNavigation="{ title: 'Zurück', path: '/legal' }" />
      <ImprintDocument />
    </div>
  </div>
</template>

<script>

import {
  ImprintDocument
} from "@profineberater/configurator-clientlib"
import BackNavigationItem from "../components/ui/BackNavigationItem.vue";

export default {
  name: 'ImprintPage',
  components: {
    ImprintDocument,
    BackNavigationItem
  },
}
</script>
